module.exports = __webpack_public_path__ + "img/focus.7efe90b0.svg";